import React from 'react';

interface IProps {
  width: number;
  height: number;
  fill: string;
  className?: string;
}

// eslint-disable-next-line react/require-default-props
export const ArrowLeft = ({ width, height, fill, className }: IProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 22 16"
    fill="none"
  >
    <path
      d="M1.22258 8.63582C0.832056 8.24529 0.832056 7.61213 1.22258 7.2216L7.58654 0.857643C7.97707 0.467119 8.61023 0.467119 9.00076 0.857643C9.39128 1.24817 9.39128 1.88133 9.00076 2.27186L3.3439 7.92871L9.00076 13.5856C9.39128 13.9761 9.39128 14.6093 9.00076 14.9998C8.61023 15.3903 7.97707 15.3903 7.58654 14.9998L1.22258 8.63582ZM21.9297 8.92871L1.92969 8.92871V6.92871L21.9297 6.92871V8.92871Z"
      fill={fill}
    />
  </svg>
);
